require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./ar-eg-team-pnampungubankinformationcenter-org.json") })
        }
      }, "path---ar-eg-team-pnampungubankinformationcenter-org");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---ar-eg-team-pnampungubankinformationcenter-org!./.cache/json/ar-eg-team-pnampungubankinformationcenter-org.json
// module id = 452
// module chunks = 231608221292675